import { useEffect, useRef } from 'react';

export const useInfiniteScroll = ({ onEndReached, isLoading, hasMore, rootMargin = '600px', threshold = 0.1 }) => {
  // threshold: o quanto do elemento precisa estar visível para disparar a ação (0.1 = 10%).
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || isLoading || !hasMore) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          // Se o elemento entra no campo de visão, chama a função recebida
          onEndReached?.();
        }
      },
      {
        root: null,
        rootMargin,
        threshold,
      }
    );

    observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, [onEndReached, isLoading, hasMore, rootMargin, threshold]);

  return ref;
};
